






































































































































import { Prop, Component, Watch, Mixins } from 'vue-property-decorator';
import {
  Button,
  Form,
  FormItem,
  Option,
  Radio,
  Select
} from 'element-ui';
import NullableInput from '@/components/element-ui/NullableInput.vue';
import ModalCard from '@/components/layout/ModalCard.vue';

import { contactService } from '@/services/ContactService';

// mixins
import countries from '@/mixins/countryOptions';
import scrollError from '@/mixins/scrollError';

import {
  ContactFields,
  ContactInput,
  CustomerOrganizationFields
} from '@/types/graphql/schemaTypes';

import rules from '@/rules/rules';
import get from 'lodash/get';

@Component({
  components: {
    ModalCard,
    'el-button': Button,
    'el-form': Form,
    'el-form-item': FormItem,
    'el-input': NullableInput,
    'el-option': Option,
    'el-select': Select
  }
})
export default class ContactUpsert extends Mixins(countries, scrollError) {
  @Prop({ default: null, type: Object }) contact!: ContactFields | null;
  @Prop({ type: String }) customerOrganizationId!: string;
  @Prop({ default: false, type: Boolean }) open!: boolean;

  private contactInput: ContactInput | null = null;
  private loading = false;
  private readonly rules = rules;

  $refs!: {
    contactForm: HTMLFormElement;
  };

  private close() {
    // resert
    this.defaultValue();
    this.$emit('close');
  }

  private submit(): void {
    this.$refs.contactForm.validate(async(valid: boolean) => {
      if (!valid || !this.contactInput) {
        this.scrollError(this.$refs.contactForm);
        return;
      }

      this.loading = true;
      let response;
      try {
        if (this.contact) {
          response = await contactService.updateContact(
            this.contactInput
          );
        } else {
          response = await contactService.createContact(
            this.contactInput
          );
        }

        if (response.data) {
          this.$emit('close');
          this.$emit('refresh');
          this.$emit('updateContact', response.data.createContact);
          this.$store.dispatch('Alert/addAlert', {
            type: 'success',
            message: this.$t('success.updated'),
            time: 2000
          });
          this.defaultValue();
        }
      } catch (e) {
        this.$store.dispatch('Alert/addAlert', {
          type: 'error',
          message: this.$t('error.push'),
          time: 2000
        });
      } finally {
        this.loading = false;
      }
    });
  }

  private defaultValue() {
    this.contactInput = {
      address: {
        city: null,
        countryCode: null,
        line1: null,
        line2: null,
        prefecture: null,
        postalCode: null
      },
      customerOrganizationId: this.customerOrganizationId,
      email: null,
      name: null,
      normalizedName: null,
      phoneNumber: null,
      shipperConsigneeStandardCode: null
    };
  }

  @Watch('contact', { immediate: true })
  private setData(contact: ContactFields) {
    if (!contact) {
      this.defaultValue();
    } else {
      this.contactInput = {
        address: {
          city: get(contact, 'address.city', null),
          countryCode: get(contact, 'address.country.unLocode', null),
          line1: get(contact, 'address.line1', null),
          line2: get(contact, 'address.line2', null),
          postalCode: get(contact, 'address.postalCode', null),
          prefecture: get(contact, 'address.prefecture', null)
        },
        customerOrganizationId: this.customerOrganizationId,
        id: contact.id || null,
        email: contact.email,
        name: contact.name || '',
        normalizedName: contact.normalizedName || null,
        phoneNumber: contact.phoneNumber || null,
        shipperConsigneeStandardCode: contact.shipperConsigneeStandardCode || null
      };
    }
  }
}
